import { createSlice } from "@reduxjs/toolkit";

const initialState = localStorage.getItem("index")
  ? JSON.parse(localStorage.getItem("index"))
  : {
      index: 0,
    };

const IndexSlice = createSlice({
  name: "index",
  initialState,
  reducers: {
    IncreaseIndex: (state, action) => {
      state.index = state.index + 1;
      localStorage.setItem("index", JSON.stringify(state));
      return state;
    },
    ResetIndex: (state, action) => {
      state.index = 0;
      localStorage.setItem("index", JSON.stringify(state));
      return state;
    },
  },
});

export const { IncreaseIndex, ResetIndex } = IndexSlice.actions;
export default IndexSlice;
